import filter from 'lodash/filter';
import head from 'lodash/head';

export class MobilityManagementMapService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.mobilityManagementMapResourceUrl = this.apiService.getResourceUrl('menus/ProgramServiceAreas');

		this.mobilityManagementMapResource = this.$resource(this.mobilityManagementMapResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
	}

	_getContentObject(values) {
		let details = filter(values, ['name', 'ProgramServiceArea']);
		return _getContentData(head(details).values);

		function _getContentData(data) {
			return data.map(value => ({
				name: value.name,
				countyName: value.county_name,
				description: value.description
			}));
		}
	}

	_getReferenceMapsObject(values) {
		let details = filter(values, ['name', 'referenceMap']);
		return _getMapsData(head(details).values);

		function _getMapsData(data) {
			return data.map(value => ({
				name: value.name,
				displayName: value.display_name
			}));
		}
	}

	getMobilitymanagementMapData() {
		const promise = this.mobilityManagementMapResource.get().$promise;

		return promise.then(details => ({
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			content: this._getContentObject(details.data.content),
			referenceMaps: this._getReferenceMapsObject(details.data.content)
		})).catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-mobility-management/planning-resources-mobility-management.service.js